// extracted by mini-css-extract-plugin
export default {"divContent":"YesNoQuestion_divContent__LxXeY","question":"YesNoQuestion_question__FEf75","subtitle":"YesNoQuestion_subtitle__Ho9KI","button":"YesNoQuestion_button__jqz7z"};